function filterCampaignsTable(tableId, field1, field2) {
    // Declare variables
    var input1, input2, filter1, table, tr, td, i, txtField1Value, txtField2Value, td_name, td_spec;
    input1 = document.getElementById(field1);
    input2 = document.getElementById(field2);
    filter1 = input1.value.toUpperCase();
    filter2 = input2.value.toUpperCase();
    table = document.getElementById(tableId);
    tr = table.getElementsByTagName("tr");

    // Loop through all table rows, and hide those who don't match the search query
    for (i = 0; i < tr.length; i++) {
        td = tr[i].getElementsByTagName("td")[0];
        if (td) {
            td_name = td.getElementsByTagName("span")[0];
            td_spec = td.getElementsByTagName("span")[1];
            txtField1Value = td_name.innerText;
            txtField2Value = td_spec.innerText;

            if (filter1 !== "" && filter2 !== "chooseyouroption".toUpperCase()) {
                if (txtField1Value.toUpperCase().indexOf(filter1) > -1 && txtField2Value.toUpperCase().indexOf(filter2) > -1) {
                    tr[i].style.display = "";
                } else {
                    tr[i].style.display = "none";
                }
            }
            else if (filter1 !== "" && filter2 == "chooseyouroption".toUpperCase()) {
                if (txtField1Value.toUpperCase().indexOf(filter1) > -1) {
                    tr[i].style.display = "";
                } else {
                    tr[i].style.display = "none";
                }
            }
            else if (filter1 == "" && filter2 !== "chooseyouroption".toUpperCase()) {
                if (txtField2Value.toUpperCase().indexOf(filter2) > -1) {
                    tr[i].style.display = "";
                } else {
                    tr[i].style.display = "none";
                }
            }
            else {
                tr[i].style.display = "";
            }
        }
    }
}

function loadQuoteForm(name) {

    if (name !== "on_form") {

        $("[id*='Doctor_SelectedValue']").first().val(name);

        //if (name != "") {
        //    window.location.href = window.location.pathname + "?dr=" + name.replaceAll(" ", "-") + "&quote=true";
        //} else {
        //    window.location.href = window.location.pathname + "?show=form";
        //}

        $("body").toggleClass("body-form-open");
        $(".popup-form").toggleClass("show-form");
    }
    else {
        $("[id*='Doctor_SelectedValue']").first().val("");

        if ($("[id*='RadioButtonsYes']").length) {
            $("[id*='RadioButtonsYes']").first().attr("checked", "false");
        }
    }
}


$(document).ready(function () {

    $("[id*='DoctorName_Value']").css("display", "none");

    // Contact Form
    $(".open-form").each(function () {
        $(this).on("click", function (e) {
            e.preventDefault();
            $("body").toggleClass("body-form-open");
            $(".popup-form").toggleClass("show-form");

            const doctorField = $("[id*='DoctorName_Value']");
            if (doctorField.length > 0) {
                doctorField.val("");
            }

        });
    });

    $(".close-button").on("click", function () {
        $(".popup-form").removeClass("show-form");
        $("body").removeClass("body-form-open");
    });

    // MCCT Form
    $(".open-form-mcct").each(function () {
        $(this).on("click", function (e) {
            e.preventDefault();
            $("body").toggleClass("body-form-open");
            $(".popup-form-mcct").toggleClass("show-form");
        });
    });

    $(".close-button").on("click", function () {
        $(".popup-form-mcct").removeClass("show-form");
        $("body").removeClass("body-form-open");
    });
   

});

